module.exports = __webpack_public_path__ + "img/鼻頭角.110afb85.jpg";